module.exports = __webpack_public_path__ + "img/08.8a7892f1.png";